<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.57812 7.44727H19.4919" stroke="#36963A" stroke-width="0.75" stroke-miterlimit="10"/>
<path d="M7.57812 11.9668H19.4919" stroke="#36963A" stroke-width="0.75" stroke-miterlimit="10"/>
<path d="M7.57812 16.4854H19.4919" stroke="#36963A" stroke-width="0.75" stroke-miterlimit="10"/>
<path d="M4.50781 7.44727H5.77231" stroke="#36963A" stroke-width="0.75" stroke-miterlimit="10"/>
<path d="M4.50781 12.0381H5.77231" stroke="#36963A" stroke-width="0.75" stroke-miterlimit="10"/>
<path d="M4.50781 16.5527H5.77231" stroke="#36963A" stroke-width="0.75" stroke-miterlimit="10"/>
</svg>
